import { Chip, Stack } from "@mui/material"
import { If } from "lib/@components/switch"
import { CriticalityIcon } from "routes/schedule/plugins/legislation-resolutions/criticality-icon"

export function AuthoringRecommendationRowMeta({ sourceLabel, stateLabel, stateColor, stateVariant, criticality }) {
    return (
        <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap>
            <Chip size="small" label={sourceLabel || "Recommendation"} color="primary" variant="outlined" />
            <Chip size="small" label={stateLabel} color={stateColor} variant={stateVariant} />
            <If value={Boolean(criticality)}>
                <CriticalityIcon criticality={criticality?.criticality} />
            </If>
        </Stack>
    )
}
